<template>
    <div class="bank-account">

        <pageheader text="Legg inn bankkontonummer"/>

        <p>
            Tast inn ditt bankkontonummer i feltet nedenfor, etterpå må du bekrefte eierskap med BankID.
        </p>

        <div v-if="!user" class="text-center  my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Laster...</strong>
        </div>

        <div v-else-if="bankaccountAddStatus === false">
            <p>
                Noe gikk feil under bekreftelse av bankkontoen.
            </p>

        </div>
        <div v-else-if="user && bankaccountAddStatus === true">
            <p>
                Bankkonto {{user.bankaccount}} bekreftet og lagt til på din konto.
            </p>

        </div>

        <div v-else-if="user && user.bankaccount">
            <p>
                Du har allerede lagt inn og bekreftet en bankkonto.
            </p>

        </div>
        <b-form v-else @submit="onSubmit" >

            <b-form-group :description="bankName" :state="accountNumber(form.accountNumber)" >
                <b-form-input type="text" placeholder="Bankkontonummer" v-model="form.accountNumber" :state="accountNumber(form.accountNumber)" trim required v-mask="'#### ## #####'" class="w-50"></b-form-input>
            </b-form-group>

            <hr>

            <div class="form-check mb-4">
                <input  v-model="form.acceptedTerms" type="checkbox" class="form-check-input" id="terms">
                <label class="form-check-label" for="terms">Jeg bekrefter <b-link variant="link" v-b-modal.termsModal>vilkårene</b-link></label>
            </div>

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <loading-button :disabled="formDisabled" >
                Bekreft med BankID
            </loading-button>


        </b-form>


        <b-modal id="termsModal" centered size="lg" title="Betalingsvilkår">

            <h2>Hvordan fyller du på spillekontoen din?</h2>
            <p>
                For å kunne spille på nett må du ha tilgjengelig kreditt på
                spillekontoen din. Dette kan gjøres lokalt på den bingoen
                du opprettet medlemskap på, eller inne på norskbingo.no
                med visa, mastercard eller vipps.
            </p>

            <h2>Angrerett på innsatt beløp til spillekonto!</h2>
            <p>
                Tilgjengelig beløp på din spillekonto kan når som helst tas
                ut  igjen ved å oppsøke den bingoen du har medlemskap
                og spillekonto hos. Det er ingen krav til å måtte spille noe
                av den kreditten som er satt inn på spillekontoen.
            </p>


            <h2>Angrerett på kjøp av spillebonger!</h2>
            <p>
                Kjøpte bonger kan angres helt frem til spillet har startet
                ved å trykke avbryt kjøp. Kjøpet er ikke avbrutt dersom
                kjøpte bonger ikke er fjernet fra skjermen og pengene
                returnert til spillekonto.
            </p>

            <h2>Blokker deg for spill!</h2>
            <p>
                Du kan når som helst blokkere deg selv ute fra spill på
                vår nettside. Hvis du tar dette valget vil du være
                utestengt for spill for 1 år. Du kan fortsatt gå til den
                bingoen du har medlemskap på, å ta ut tilgjengelig
                kreditt på din spillekonto. Ved å stenge deg ute fra
                nettspill hindrer deg ikke i å spille hos din lokale bingo.
            </p>
        </b-modal>




    </div>
</template>

<script>

import LoadingButton from '@/components/LoadingButton.vue';

// @ is an alias to /src
export default {
    name: 'Bankaccount',
    components: {
        LoadingButton
    },
    data() {
        return {
            user: null,
            bankaccountAddStatus: null,
            form: {
                accountNumber: null,
                acceptedTerms: false
            },
            errors:[],
            formDisabled: false
        }
    },

    mounted() {

        // Fetch params from query string and show success if done with bankid
        let query = this.$route.query;
        let key = query.state;

        // BankID error
        if (query.error) {
            this.$api.patch(`/users/${this.$store.getUser().card_id}/bankaccount/${key}/`, {
                error: query.error
            })
            this.bankaccountAddStatus = false;
        }

        // BankID success
        else if ( query.state && query.session_state ) {
            let session_state = query.session_state;
            let code = query.code;

            this.$api.patch(`/users/${this.$store.getUser().card_id}/bankaccount/${key}/`, {
                session_state: session_state,
                code: code
            }).then((response) => {
                this.bankaccountAddStatus = true;
            }).catch((error) => {
                this.bankaccountAddStatus = false;
            }).finally(() => {
                this.fetchUser();
            });
        }

        // Get user data
        else {
            this.fetchUser();
        }

    },


    methods: {
        fetchUser() {
            this.$api.get(`/users/${this.$store.getUser().card_id}/`)
            .then((response) => {
                this.user = response.data.data
            })
            .catch((response) => {
                // Keep loading
            });
        },

        amountSelected(amount) {
            this.form.amount = amount
        },
        onSubmit(e) {
            e.preventDefault()

            this.errors = []

            if (!this.form.accountNumber) this.errors.push('Verdi mangler.')
            if (!this.form.acceptedTerms) this.errors.push('Du må akseptere vilkårene.')
            if (!this.accountNumber(this.form.accountNumber)) this.errors.push('Bankkontonummer ikke gyldig.')


            if (this.errors.length) return;

            this.formDisabled = true

            let bankaccount = this.form.accountNumber.replace(/\s/g, '');

            this.$api.post(`/users/${this.$store.getUser().card_id}/bankaccount/`, {
                bankaccount: bankaccount,
            })
            .then((response) => {
                // Send user to BankID window
                window.location = response.data.redirect_url;
            })
            .catch((error) => {
                this.errors.push('Det har oppstått en feil hos oss. Kontakt magikerne.')

                this.formDisabled = false
            });



        }

    },
    computed: {
        heading:  function() {
            if (this.user) return `Ta ut penger fra ${this.user.hall.owner.name} (${this.user.hall.owner.orgnum})`;
            else return "Ta ut penger fra ...";
        },
        bankName: function() {
            return this.getBankName(this.form.accountNumber);
        }
    }
}

</script>


<style lang="scss">

.transferAmount {
    font-size: 1.5em;
    margin-right: 0.5em;
    margin-top: 0.5em;
}
.errors {
    font-size: 0.8em;
    margin-top: 2em;
}
.errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}


#termsModal h2 {
    font-size: 1.2em;

}

</style>
